module.exports = __webpack_public_path__ + "img/under-maintenance-dark.57c226d3.svg";